import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AnalyticsContainer, SmaGroupsContainer } from 'src/scenes/Project';


const routes = [
  {
    path: 'analytics',
    Component: AnalyticsContainer,
  },
  {
    path: 'groups',
    Component: SmaGroupsContainer,
  },
];

const MonitoringPlanRoutes = props => {
  const match = useRouteMatch();
  const { path: basePath, url: routeUrl } = match;
  const redirectToMonitoringPlanMainPage = () => <Redirect to={`${routeUrl}/analytics`} />;

  const filteredRoutes = routes.filter(({ allowOnly }) => !allowOnly || allowOnly.includes(props.userRoleId));

  return (
    <Switch>
      {filteredRoutes.map(({ path, Component, hasNestedRoutes }, index) =>
        <Route
          key={index}
          exact={!hasNestedRoutes}
          path={`${basePath}/${path}`}
          render={rProps => <Component {...rProps} {...props} />}
        />)
      }
      <Route path={basePath} component={redirectToMonitoringPlanMainPage} />
    </Switch>
  );
};

MonitoringPlanRoutes.propTypes = {
  userRoleId: PropTypes.oneOf([ 'admin', 'user', 'consultant' ]),
};


export { MonitoringPlanRoutes };
